import { Banner } from '@stenajs-webui/elements';
import { Errors } from '../../common/texts';

export const NoSailingSelected = () => (
  <Banner text={Errors.SelectDepartureTime} variant={'warning'} />
);
